const smtCodeSnippetComponent = {
  header: {
    bgColor: {
      default: 'gray.100',
      _dark: '#011a2f'
    },
    text: {
      color: {
        default: 'gray.600',
        _dark: 'gray.400'
      }
    },
    _hover: {
      text: {
        color: {
          default: 'gray.700',
          _dark: 'gray.100'
        }
      }
    }
  },
  body: {
    bgColor: {
      default: 'gray.50',
      _dark: '#011627'
    }
  },
  borderColor: {
    default: 'gray.200',
    _dark: 'rgba(45, 55, 72, 0.75)'
  }
};

export default smtCodeSnippetComponent;
